export var VERTICAL_MARGIN = 32;
export var HORIZONTAL_MARGIN = 16;
export var AXIS_LABEL_PADDING = 48;
